<div class="conversa-area" [class.com-fundo]="comFundo">

  <div class="conversa-carregando" *ngIf="carregando">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <div class="conversa-vazia" *ngIf="!carregando && !mensagens?.length">
    <mat-icon>forum</mat-icon>
    <p>{{ vazioTitulo }}</p>
    <span>{{ vazioDica }}</span>
  </div>

  <div class="conversa" *ngIf="!carregando && mensagens?.length">
    <ng-container *ngFor="let m of mensagens; let i = index; trackBy: chaveDaMensagem">

    <div class="dia" *ngIf="abreODia(i)"><span>{{ rotuloDoDia(m) }}</span></div>

    <div class="balao-linha"
         [ngClass]="recebida(m) ? 'recebida' : 'enviada'">
      <div class="balao">
        <div class="balao-autor" *ngIf="recebida(m) && m.pushName">{{ m.pushName }}</div>

        <!-- Mídia: o arquivo só é buscado quando alguém pede -->
        <div class="balao-midia" *ngIf="temMidia(m)">
          <button mat-stroked-button class="midia-abrir"
                  *ngIf="!midia(m).url && !midia(m).carregando && !midia(m).erro"
                  (click)="m.messageType === 'DOCUMENT' ? baixar(m) : abrirMidia(m)">
            <mat-icon>{{ iconeDaMidia(m) }}</mat-icon>
            {{ acaoDaMidia(m) }}
          </button>

          <div class="midia-carregando" *ngIf="midia(m).carregando">
            <mat-spinner diameter="20"></mat-spinner>
            <span>buscando o arquivo…</span>
          </div>

          <div class="midia-erro" *ngIf="midia(m).erro">
            <mat-icon>cloud_off</mat-icon>
            <span>{{ midia(m).erro }}</span>
          </div>

          <audio class="midia-audio" *ngIf="midia(m).url && m.messageType === 'AUDIO'"
                 controls autoplay [src]="midia(m).url"></audio>

          <img class="midia-imagem" *ngIf="midia(m).url && (m.messageType === 'IMAGE' || m.messageType === 'STICKER')"
               [src]="midia(m).url" [alt]="midia(m).fileName || 'imagem'"
               (click)="baixar(m)">

          <video class="midia-video" *ngIf="midia(m).url && m.messageType === 'VIDEO'"
                 controls [src]="midia(m).url"></video>

          <button mat-button class="midia-arquivo" *ngIf="midia(m).url && m.messageType === 'DOCUMENT'"
                  (click)="baixar(m)">
            <mat-icon>attach_file</mat-icon>
            {{ midia(m).fileName || 'arquivo' }}
          </button>

          <!-- Aparece sem precisar abrir o arquivo: o servidor busca e guarda a mídia se ainda não
               estiver no S3, e então cria o vínculo com cadastro, lançamento ou agenda. Exigir
               abrir antes era uma amarra da tela, não do servidor. -->
          <button mat-button class="midia-anexar" *ngIf="permiteAnexar"
                  (click)="anexarArquivo.emit(m); $event.stopPropagation()"
                  matTooltip="Anexar este arquivo ao cadastro, lançamento ou agenda">
            <mat-icon>attach_file</mat-icon> Anexar
          </button>
        </div>

        <div class="balao-texto" *ngIf="temMidia(m) ? legenda(m) : conteudo(m)">
          {{ temMidia(m) ? legenda(m) : conteudo(m) }}
        </div>

        <div class="balao-rodape">
          <button class="balao-reenviar" *ngIf="permiteReenviar && falhou(m)" (click)="pedirReenvio(m)">
            reenviar
          </button>
          <span class="balao-hora">{{ m.timestamp | date:'HH:mm' }}</span>
          <mat-icon class="balao-status" *ngIf="!recebida(m)"
                    [ngClass]="{ 'lido': m.sendStatus === 'READ', 'falhou': falhou(m) }"
                    [matTooltip]="m.sendStatus">
            {{ iconeStatus(m) }}
          </mat-icon>
        </div>
      </div>
    </div>

    </ng-container>
  </div>
</div>
